import React from 'react'

export const PackIcon = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M4 4H17C18.6569 4 20 5.34315 20 7V20H4V4Z" fill="#BDBDBD" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4 8.5V4H9H15H17.3333C18.8061 4 20 5.19391 20 6.66667V8.5C20 9.88071 18.8807 11 17.5 11C16.1193 11 15 9.88071 15 8.5V8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8V8.5C9 9.88071 7.88071 11 6.5 11C5.11929 11 4 9.88071 4 8.5Z"
			fill="#4A4A4A"
		/>
		<path d="M7 15C7 13.8954 7.89543 13 9 13C10.1046 13 11 13.8954 11 15V20H7V15Z" fill="white" />
	</svg>
)
